const initialState = {
  items: [],
  count: 0,
  item: null,
  isLoading: false
};

export function plfCategoryReducer(state = initialState, action) {
  const { data, plfCategory: item, type } = action;
  switch (type) {
    case 'PLF_CATEGORY_ERROR':
      return Object.assign({}, state, {
        isLoading: false
      });
    case 'PLF_CATEGORY_CREATE':
      return Object.assign({}, state, {
        item: null,
        isLoading: true
      });
    case 'PLF_CATEGORY_CREATE_OK':
      return Object.assign({}, state, {
        item,
        isLoading: false
      });

    case 'PLF_CATEGORY_GET':
      return Object.assign({}, state, {
        item: null,
        isLoading: true
      });
    case 'PLF_CATEGORY_GET_OK':
      return Object.assign({}, state, {
        item,
        isLoading: false
      });

    case 'PLF_CATEGORIES_GET':
      return Object.assign({}, state, {
        items: [],
        count: 0,
        isLoading: true
      });
    case 'PLF_CATEGORIES_GET_OK':
      return Object.assign({}, state, {
        items: data.items,
        count: data.count,
        isLoading: false
      });

    default:
      return state;
  }
}
